import { useEffect, useMemo } from 'react'
import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import CardComponent from '../CardComponent/CardComponent'
import EngagementCard from '../CardComponent/EngagementCard'

const MpCard = ({ selectedCard, tenure, flag }) => {
  const mpList = useSelector((state) => state?.mpList?.data)
  const mpEngagementData = useSelector((state) => state?.getEngagementMpData?.data)

  const mpData = useMemo(() => {
    if (!selectedCard?.hasOwnProperty('csvPath')) {
      return mpList?.slice(0, 9) || []
    } else {
      return mpEngagementData?.slice(0, 9) || []
    }
  }, [mpList, flag, selectedCard, mpEngagementData])

  return (
    <Grid container spacing={3}>
      {selectedCard?.hasOwnProperty('csvPath') &&
        mpData.map((mp, index) => <EngagementCard key={index} selectedCard={selectedCard} mp={mp} index={index + 1} />)}
      {!selectedCard?.hasOwnProperty('csvPath') &&
        mpData.map((mp, index) => <CardComponent key={index} selectedCard={selectedCard} mp={mp} index={index + 1} />)}
    </Grid>
  )
}

export default MpCard
